@if (showBadge()) {
    <ms-help-box-badge class="best-odds" [boxType]="'bestoddsguarantee'" />
}
